export function randomCode(index1, index2) {
  const code = ("" + Math.random()).substring(index1, index2);

  return code;
}

export function getFirstWord(sentence) {
  const words = sentence.trim().split(" ");
  if (words.length > 0) {
    return words[0].toLowerCase();
  }
  return "";
}

export function otpCode() {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";

  // Function to get a random element from a given string
  const getRandomElement = (str) =>
    str.charAt(Math.floor(Math.random() * str.length));

  // Generate 3 random letters and 3 random numbers
  let code = "";
  for (let i = 0; i < 3; i++) {
    code += getRandomElement(letters);
    code += getRandomElement(numbers);
  }

  // Shuffle the code to mix letters and numbers
  code = code
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");

  return code;
}

export function lifeTime(time) {
  const lifeTime = time * 60 * 1000; // 3 minutes in milliseconds

  return lifeTime;
}
